import React from "react";

import type { Sale } from "../types";

const SalesList = React.lazy(() =>
  import("./SalesList").then((m) => ({ default: m.SalesList })),
);
const SalesCreate = React.lazy(() =>
  import("./SalesCreate").then((m) => ({ default: m.SalesCreate })),
);
const SalesEdit = React.lazy(() =>
  import("./SalesEdit").then((m) => ({ default: m.SalesEdit })),
);

export default {
  list: SalesList,
  create: SalesCreate,
  edit: SalesEdit,
  // Not lazy: this runs wherever a sale is referenced, including inside lists
  // of other resources, so it must be available without loading a screen.
  recordRepresentation: (record: Sale) =>
    `${record.first_name} ${record.last_name}`,
};
